


import { exportRowsAsXls } from './exportRowsAsXls';

export const exportVisibleColumnsAsXls = ({
  table,
  exportColumns = [],
  fileName = 'export.xlsx',
  worksheetName = 'Sheet1',
}) => {
  const visibleColumnIds = new Set(
    (table?.getVisibleLeafColumns?.() || []).map((column) => column.id),
  );

  const selectedColumns = exportColumns.filter((column) =>
    visibleColumnIds.has(column.id),
  );

  if (!selectedColumns.length) {
    return;
  }

  const rows = (table?.getPrePaginationRowModel?.().rows || []).map((row) =>
    selectedColumns.map((column) => column.getValue(row.original)),
  );

  exportRowsAsXls({
    headers: selectedColumns.map((column) => column.header),
    rows,
    fileName,
    worksheetName,
  });
};